import React from "react";

const MoreApps = ({ copy, logo, pezzulLogo }) => (
  <section className="more-apps section-wrap" aria-labelledby="more-apps-title">
    <div className="more-apps__intro">
      <p className="eyebrow">{copy.eyebrow}</p>
      <h2 id="more-apps-title">{copy.title}</h2>
      <p>{copy.body}</p>
    </div>
    <div className="more-apps__rail">
      <a className="app-card app-card--current" href="#top">
        <img src={logo} alt="" />
        <span><strong>MNEZY</strong><small>{copy.currentBody}</small></span>
        <em>{copy.current}</em>
      </a>
      <a
        className="app-card app-card--pezzul"
        href="https://pezzul.marclaberge.org/"
        target="_blank"
        rel="noreferrer"
      >
        <img src={pezzulLogo} alt="" />
        <span><strong>Pezzul</strong><small>{copy.pezzulBody}</small></span>
        <em>{copy.pezzulStatus}</em>
      </a>
      <div className="app-card app-card--future">
        <span className="app-card__placeholder" aria-hidden="true"><i /><i /><i /><i /></span>
        <span><strong>{copy.next}</strong><small>{copy.nextBody}</small></span>
        <em>{copy.nextStatus}</em>
      </div>
    </div>
  </section>
);

export default MoreApps;
